/**
 * Mantiene etiquetas B2B en tarjetas tras inyección de precios WSAIO (.coll_d).
 * IVA y "/ unidad" viven fuera de .product-card-title-price; este script refuerza
 * tarjetas cargadas dinámicamente y reinyecta meta si WSAIO la elimina.
 */
(function () {
  const LABELS = window.B2B_CARD_PRICE_LABELS || {
    vatShort: 'IVA no incl.',
    perUnit: '/ unidad',
  };

  const CARD_SEL = 'product-card .coll_p';

  function ensureCardPriceMeta(collP) {
    if (!collP) return;

    const titlePrice = collP.querySelector('.product-card-title-price');
    if (!titlePrice) return;

    if (!collP.querySelector('.product-card-price-row')) {
      const row = document.createElement('div');
      row.className = 'product-card-price-row';
      titlePrice.parentNode.insertBefore(row, titlePrice);
      row.appendChild(titlePrice);
    }

    if (!collP.querySelector('.iva--short')) {
      const iva = document.createElement('p');
      iva.className = 'iva iva--compact iva--short';
      iva.textContent = LABELS.vatShort;
      collP.appendChild(iva);
    }
  }

  function enhanceCollP(collP) {
    ensureCardPriceMeta(collP);
  }

  function watchCollP(collP) {
    enhanceCollP(collP);

    let timer;
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => enhanceCollP(collP), 50);
    };

    // Solo observar cambios en hijos directos/indirectos (no atributos) — WSAIO inyecta nodos DOM
    const observer = new MutationObserver(schedule);
    observer.observe(collP, {
      childList: true,
      subtree: true,
    });

    // Un timer de seguridad justo después del setTimeout(2500) de WSAIO collections()
    setTimeout(schedule, 2800);

    // WSAIO termina de inyectar precios dentro de su propio ciclo de ~2.5s; pasado ese
    // margen ya no hay mutaciones relevantes que vigilar en esta tarjeta. Desconectar aquí
    // evita acumular un MutationObserver vivo por tarjeta indefinidamente — con scroll
    // infinito en colecciones grandes (150+ productos) esto crecía sin límite y degradaba
    // el scroll hasta colapsar en iOS, independientemente del peso de las imágenes.
    setTimeout(() => observer.disconnect(), 3500);
  }

  function init() {
    document.querySelectorAll(CARD_SEL).forEach(watchCollP);
  }

  function observeNewCards() {
    // Acotar al contenedor real de la grid (colección/búsqueda/wishlist) cuando existe, en
    // vez de vigilar todo document.body: cada mutación en cualquier parte de la página
    // (WSAIO, wishlist, header, chat widget...) disparaba un querySelectorAll de barrido
    // completo sobre el subárbol añadido, un coste que crecía con cada tanda de scroll
    // infinito. Si no existe el contenedor (home, PDP, recomendaciones), se mantiene el
    // comportamiento anterior sobre document.body.
    const root = document.getElementById('ProductGridContainer') || document.body;
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(CARD_SEL)) watchCollP(node);
          node.querySelectorAll?.(CARD_SEL).forEach(watchCollP);
        });
      });
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      observeNewCards();
    });
  } else {
    init();
    observeNewCards();
  }
})();
